function manageMarketingConsentsDependencies() {
    // If the overall marketing consent checkbox is toggled, modify also the specific email/sms consents
    $('body').on('change', '#add-to-email-list, #edit-add-to-email-list', function () {
        const isChecked = $(this).is(':checked');
        $('.js-partial-consent').prop('checked', isChecked);
    });

    // If the a partial consent is given (through emails or sms), toggle also the overall marketing consent
    $('body').on('change', '.js-partial-consent', function () {
        const partialConsentsChecked = $('.js-partial-consent:checked').length > 0;
        $('#add-to-email-list').prop('checked', partialConsentsChecked);
        $('#edit-add-to-email-list').prop('checked', partialConsentsChecked);
    });
}

module.exports = {
    manageMarketingConsentsDependencies: manageMarketingConsentsDependencies
};